import React from 'react';
import styled from 'styled-components';
import { Chip as MuiChip } from '@material-ui/core';

const Chip = styled(({
  color,
  margin,
  height,
  backgroundcolor,
  ...otherProps
}) => (
  <MuiChip
    {...otherProps}
  />
))`
  margin: ${({ margin }) => margin};
  height: ${({ height }) => height};
  color: ${({ color }) => color};
  background-color: ${({ backgroundcolor }) => backgroundcolor};
  &:focus {
    background: ${({ backgroundcolor }) => backgroundcolor};
    color: ${({ color }) => color};
  }
`;

export default Chip;
